// extracted by css-extract-rspack-plugin
export default {"upcoming-update-modal":"upcoming-update-modal-LHJUF0","upcomingUpdateModal":"upcoming-update-modal-LHJUF0","text":"text-ybDVG9","btn":"btn-o26kNJ"};